/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { CheckWhetherUserCanCreateMeetingsService } from './services/check-whether-user-can-create-meetings.service';
import { MeetingService } from './services/meeting.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    CheckWhetherUserCanCreateMeetingsService,
    MeetingService,
    ApiConfiguration
  ],
})
export class MeetingApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<MeetingApiModule> {
    return {
      ngModule: MeetingApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: MeetingApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('MeetingApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
